import {
  getApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsId,
  getGetApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { GetApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsId200 } from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';
import type { KeyedMutator } from 'swr';

type Args = {
  /** パートナーの 3 文字コード */
  threeLetterCode: string;
  /** 利用企業 ID */
  clientId: number;
  /** 企業契約期間 ID */
  termId: number;
};

type ReturnType = {
  /** API レスポンス（useFetch の data をそのまま返す） */
  data: GetApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsId200;
  /** SWR の mutate 関数（保存後のキャッシュ再検証用） */
  mutate: KeyedMutator<GetApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsId200>;
};

type IUseGetPartnerAdminsClientContractTerm = (args: Args) => ReturnType;

/**
 * パートナー管理者向け企業契約期間単一取得フック
 *
 * - `partner_admins/clients/{clientId}/client_contracts/{termId}` から単一の契約期間を取得して返す
 * - PartnerAdmin 用 API は内部金額（パートナー販売手数料・Leafea収益単価）を含まない
 * - Suspense を使用してデータを取得する
 * - mutate は保存後のキャッシュ再検証用に返す
 */
export const useGetPartnerAdminsClientContractTerm: IUseGetPartnerAdminsClientContractTerm = ({
  threeLetterCode,
  clientId,
  termId,
}) => {
  const { data, mutate } =
    useFetch<GetApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsId200>(
      getGetApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdKey(
        threeLetterCode,
        clientId,
        termId
      ),
      () =>
        getApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsId(
          threeLetterCode,
          clientId,
          termId
        ),
      { suspense: true }
    );

  return { data, mutate };
};
